module.exports = __webpack_public_path__ + "static/media/hu.844eeb9e.svg";